import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import api from '@survey/api'

import GridView from '@appbase/components/GridView/GridView.vue'
import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'
import modalHelper from '@appbase/util/modal-helper'
import { dispatchEventBus } from '@appbase/util'

@Component({
    components: {
        ModalLayout,
        GridView
    }
})
export default class CompanySelectModal  extends Vue {
    @Prop({ type: Object }) value!: { eventname: string };

    companyHeaders: gridView.Header[] = [
        { displayName: '회사명', rowKey: 'companyName', align: 'left', width: '200px' }
    ];
    companyModels: gridView.ModelItem<survey.Company>[] = [];
    selectedCompanys: survey.Company[] = [];

    created() {
        api.survey.getOrgCompanys().then(res => {
            this.companyModels = res.companies;
        });
    }

    onConfirmClick() {
        dispatchEventBus(window, this.value.eventname, this.selectedCompanys);
        modalHelper.close();
    }

    onCancelClick() {
        modalHelper.close();
    }
}